import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

export default class ProductHeroColumns extends HTMLElement {
  constructor() {
    super();

    // bindings
    this.onClickSliderThumb = this.onClickSliderThumb.bind(this);

    // privates
    this._node = this;
    this._offset = 96;
    this._event_horizon = 0;
    this._current_index = -1;
    this._thumbs = this._node.querySelectorAll('.thumb');
    this._swiper_el = this._node.querySelector('.col-swiper');
    this._slide = this._swiper_el.querySelectorAll('.swiper-slide');
    this._swiper_index = 0;

    // events
    if (this._thumbs.length > 0) {
      this._swiper = new Swiper(this._swiper_el, {
        a11y: false,
        speed: 333,
        loop: false,
        draggable: true,
        autoHeight: false,
        slidesPerView: 'auto',
        watchOverflow: true,
        pagination: {
          enabled: false
        },
        keyboard: {
          enabled: false
        },
        on: {
          slideChange: (swiper_data) => {
            this._swiper_index = swiper_data.realIndex;
            this.updateSliderThumb();
          }
        }
      });

      this._thumbs.forEach((el) => {
        el.addEventListener('click', this.onClickSliderThumb);
      });

      this.updateSliderThumb();

      this._swiper.on('slideChangeTransitionEnd', (data) => {
        let video = this._slide[data.activeIndex].querySelector('video');
        if (video) {
          video.pause();
          video.currentTime = 0;
          video.play();
        }
      });
    }
  }

  updateSliderThumb() {
    this._thumbs.forEach((el) => {
      el.classList.remove('--active');
    });

    this._thumbs[this._swiper_index].classList.add('--active');
  }

  onClickSliderThumb(e) {
    let el = e.currentTarget,
        index = [...el.parentElement.children].indexOf(el);

    if (!el.classList.contains('--active')) {
      this._swiper.slideTo(index);
    }
  }

  /**
   * Handle unmount.
   */
  disconnectedCallback() {
    if (this._thumbs.length > 0) {
      this._thumbs.forEach((el) => {
        el.removeEventListener('click', this.onClickSliderThumb);
      });
    }
  }
}
